import { render, staticRenderFns } from "./app-ad-route-link.vue?vue&type=template&id=bb4fc5c0&scoped=true&"
import script from "./app-ad-route-link.vue?vue&type=script&lang=js&"
export * from "./app-ad-route-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4fc5c0",
  null
  
)

export default component.exports